// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light', // Ensures light mode
    primary: {
      main: '#000000', // Use black or dark gray as main accent
    },
    background: {
      default: '#FFFFFF', // Pure white background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
});

export default theme;
